/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { TabMenu } from 'primereact/tabmenu';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { SplitButton } from 'primereact/splitbutton';
import { RadioButton } from 'primereact/radiobutton';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';


import ModalPreview from '@components/Section/ModalPreview'
import FileInput from '@components/FileInput';

import { SET_VALUES_SECTION } from '@constants/actionType';
import { LANGUAGE_DEFAULT } from '@constants/general';

import { findSectionInTree, getValueLanguageObj } from '@utils/general';

import store from '@store';

const URL_MICROSITIO = 'https://www.complianceamx.com'
const URL_MICROSITIO_DOCUMENTS = `${URL_MICROSITIO}/section`

class DocumentsCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      sectionsOptions: [],
      languagePreview: [],
      errors: [],
      showModalPreview: {
        title: '',
        visible: false,
        children: ''
      }
    }
    // this.initialValuesForm = {
    //     title: '',
    //     cards: [],
    // }
    this.initialValuesCardForm = {
      backgroundImg: [],
      sectionReference: '',
      pathRedirect: ''
    };
    this.initialValuesCardFormByLanguage = {
      title: '',
      btnText: '',
      description: '',
    };
  }

  componentDidMount() {
    let { keysLenguages, _documentsCards, itemsTabsLenguages, t } = this.props;
    if (_documentsCards) {
      _documentsCards.cards.map(item => {
        if (!item?.sectionReference && item?.pathRedirect) {
          item.sectionReference = item.pathRedirect.replace(`${URL_MICROSITIO_DOCUMENTS}/`, "")
        }
      })
      this.setState({
        ..._documentsCards,
      });
    } else {
      let state = {
        cards: [{ ...this.initialValuesCardForm }]
      }
      keysLenguages.map((item) => {
        state.cards[0][item] = { ...this.initialValuesCardFormByLanguage }
      })
      this.setState({...state})
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      let label = t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '')
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    // const sectionsOptions = [
    //   { label: "Datos personales", value: "@{/section/Datos-personales}" },
    //   { label: "Prevención de Lavado de Dinero", value: "@{/section/Prevención-de-Lavado-de-Dinero}" },
    //   { label: "Prevención del Delito", value: "@{/section/Prevención-del-Delito}" },
    //   { label: "Cumplimiento Laboral", value: "@{/section/Cumplimiento-Laboral}" },
    //   { label: "Anticorrupción", value: "@{/section/Anticorrupción}" },
    // ]
    this.getSectionsChilds()
    this.setState({ languagePreview })
    this.setState({ loadingPage: false });
  }

  getSectionsChilds = () => {
    const { categoriesSectionCatalog, selectedNavegationTree, id } = this.props
    console.log('selectedNavegationTree', typeof selectedNavegationTree)
    console.log('categoriesSectionCatalog', categoriesSectionCatalog)
    const getChildSections = findSectionInTree(parseInt(id, 10), categoriesSectionCatalog)
    console.log('getChildSections', getChildSections)
    const sectionsOptions = getChildSections?.children.map((item) => {
      const name = getValueLanguageObj(item.nombre)
      const formatName = `@{/section/${name.replaceAll(" ", "-")}}`
      return {
        label: getValueLanguageObj(item.nombre),
        value: formatName
      }
    })
    // const sectionsOptions = [
    //   { label: "Datos personales", value: "@{/section/Datos-personales}" },
    //   { label: "Prevención de Lavado de Dinero", value: "@{/section/Prevención-de-Lavado-de-Dinero}" },
    //   { label: "Prevención del Delito", value: "@{/section/Prevención-del-Delito}" },
    //   { label: "Cumplimiento Laboral", value: "@{/section/Cumplimiento-Laboral}" },
    //   { label: "Anticorrupción", value: "@{/section/Anticorrupción}" },
    // ]
    console.log('sectionsOptions', sectionsOptions)
    if (sectionsOptions ) this.setState({ sectionsOptions })
  }

  onChangeCard = ({target}) => {
    const [index, language, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][language][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCardSimple = ({target}) => {
    const [index, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  uploadFileCard = (files, isImage, index) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    const newCard = this.state.cards
    newCard[index].backgroundImg = [data]
    this.setState({ cards: newCard }, () => this.validateFieldsOnchange(`${index}-backgroundImg`, data));
  };

  removeFileCard = (index) => {
    const newCard = this.state.cards
    newCard[index].backgroundImg = []
    this.setState({ cards: newCard });
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { cards, sectionsOptions } = this.state
    let errors = {}
    cards.map((item, index) => {
      if (!item.backgroundImg.length) errors = { ...errors, [`${index}-backgroundImg`]: `${t('Imagen')} ${t('es requerido')}` }
      if (!item.sectionReference.length && sectionsOptions.length) errors = { ...errors, [`${index}-sectionReference`]: `${t('Categoria de documento')} ${t('es requerido')}` }
      if (!item[LANGUAGE_DEFAULT].title) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-title`]: `${t('Texto Botón')} ${t('es requerido')}` }
      if (!item[LANGUAGE_DEFAULT].btnText) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-btnText`]: `${t('Titulo')} ${t('es requerido')}` }
      if (!item[LANGUAGE_DEFAULT].description || item[LANGUAGE_DEFAULT].description === '\n') errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}` }
    })
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    let validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props
    await this.setValuesToStateGlobal()
    success();
  };

  setValuesToStateGlobal = async () =>  {
    const { cards } = this.state
    const formatCards = cards.map(item => {
      item.pathRedirect = `${item.sectionReference}`
      return item
    })
    return await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: { documentsCards: {cards: formatCards} },
    });
  }

  onPreview = async (language) => {
    await this.setValuesToStateGlobal()

    return this.setState({showModalPreview: {
      visible: true,
      language,
    }})
  }

  onHideModalPreview = () => {
    this.setState({showModalPreview: { visible: false }})
  }

  template = (options, index) => {
    const { t } = this.props;
    const getCards = this.state.cards;
    const toggleIcon = options.collapsed
      ? 'pi pi-chevron-down'
      : 'pi pi-chevron-up';
    const className = `${options.className} p-jc-beetween`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <div>
          <button
            type="button"
            className={options.togglerClassName}
            onClick={options.onTogglerClick}
          >
            <span className={toggleIcon} />
            <Ripple />
          </button>
          <span className={titleClassName}>
            {t('Bloque')} {index + 1} {t('de')} {getCards.length}
          </span>
        </div>
        { getCards.length !== 1 && (
          <div>
            <Button
              icon="pi pi-trash"
              type="button"
              className="p-button-text p-button-plain"
              onClick={() => this.removeService(index)}
            />
          </div>
        )}
      </div>
    );
  };

  addService = () => {
    const { keysLenguages } = this.props;
    const newCards = this.state.cards
    let stateCard =  [{ ...this.initialValuesCardForm }]
    keysLenguages.map((item) => {
      stateCard[0][item] = { ...this.initialValuesCardFormByLanguage }
    })
    newCards.push(stateCard[0])
    this.setState({ cards: newCards })
  };

  removeService = (index) => {
    const newCards = this.state.cards
    newCards.splice(index, 1)
    this.setState({ cards: newCards })
  };

  render() {
    const {
      t,
      btnSubmitLoading,
      itemsTabsLenguages,
      keysLenguages,
      onBack,
    } = this.props;
    const { activeTabIndex, loadingPage, showModalPreview, languagePreview, errors, sectionsOptions } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderCards = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      const getCards = this.state.cards;
      return getCards.map((item, index) => (
        <div className="p-col-12" key={`card-${index}`}>
          <Panel
            headerTemplate={(e) => this.template(e, index)}
            collapsed={index >= 1}
            toggleable
          >
            <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-6 p-lg-6">
                <FileInput
                  onChangeFile={(files, isImage) => this.uploadFileCard(files, isImage, index)}
                  files={this.state.cards[index].backgroundImg}
                  removeAllFiles={() => this.removeFileCard(index)}
                  removeFile={() => this.removeFileCard(index)}
                  accept="/image*"
                  txtDrop={t('Arrastra y suelta el archivo')}
                  classNameBorderMain={classNames({
                    'p-invalid': isFormFieldValid(`${index}-backgroundImg`),
                  })}
                />
                {getFormErrorMessage(`${index}-backgroundImg`)}
              </div>
              <div className="p-col-12 p-md-6 p-lg-6"/>
              <div className="p-col-12 p-md-6 p-lg-6">
                <label className="p-mr-2 p-text-bold">{t('Categoria de documento')}:</label>
                <Dropdown
                  name={`${index}-sectionReference`}
                  value={this.state.cards[index].sectionReference}
                  options={sectionsOptions}
                  onChange={this.onChangeCardSimple}
                  optionLabel="label"
                  filter
                  filterBy="label"
                  placeholder=""
                  style={{ width: '100%' }}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-sectionReference`),
                  })}
                  showClear={false}
                />
                {getFormErrorMessage(`${index}-sectionReference`)}
              </div>
              <div className="p-col-12 p-md-6 p-lg-6" />
              <div className="p-col-12">
                {itemsTabsLenguages && (
                  <TabMenu
                    model={itemsTabsLenguages}
                    activeIndex={activeTabIndex}
                    onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                  />
                )}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                {t('Título', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-title`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].title}
                  onChange={this.onChangeCard}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-title`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-title`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                {t('Texto Botón', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-btnText`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].btnText}
                  onChange={this.onChangeCard}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-btnText`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-btnText`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="description" className="p-text-bold">
                  {t('Descripción', {lng: prefixLenguage })}
                </label>
                <InputTextarea
                  name={`${index}-${prefixLenguage}-description`}
                  style={{ height: '200px' }}
                  value={this.state.cards[index][prefixLenguage].description}
                  onChange={this.onChangeCard}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-description`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-description`)}
              </div>
            </div>
          </Panel>
        </div>
      ));
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-text-right p-d-flex p-jc-end">
              <Button
                label={t("Agregar bloque")}
                type="button"
                className="p-button-info"
                onClick={() => this.addService()}
                style={{width: '150px'}}
              />
            </div>
            {renderCards()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-primary"
                model={languagePreview}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
        <div>
          { showModalPreview.visible && (
            <ModalPreview
              language={showModalPreview.language}
              onHide={this.onHideModalPreview}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _documentsCards: state.section.documentsCards,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,

  selectedNavegationTree: state.section.selectedNavegationTree,
  id: state.section.id
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(DocumentsCards);
